module.exports = {"id":"162981","name":"James Morrison","rating":"76","photo":"./data/images/photos/4/162981.png","club":{"name":"West Bromwich","logo":"./data/images/clubs/WestBromwich.png"},"positions":["MOC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JamesMorrison0.json
// module id = 1900
// module chunks = 0